import React, { Suspense, lazy } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './styles/main.scss';

import Loader from './components/common/loader';

const Login = lazy(() => import('./components/login'));
const CancelBusBooking = lazy(() => import('./components/cancelBusBooking'));
const SelectSeatsTable = lazy(() => import('./components/cancelBusBooking/SelectSeatsTable'));
const cancelledGuest = lazy(() => import('./components/cancelled/cancelGuest'))
const cancelled = lazy(() => import('./components/cancelled'))

const SearchTourPackage = lazy(() => import("./components/search_tour_package/index"))
const ChartTourPackage = lazy(() => import("./components/chart_tour_package/index"));
const CheckoutTourPackage = lazy(() => import("./components/checkout tour_package/index"));

const CancelTourPackage = lazy(() => import('./components/cancelled_tour_package/CancelTourPackage'))
const SelectSeatsTableTourPackage = lazy(() => import('./components/cancel_tour_package_booking/SelectSeatsTable'));

const App = ({ store }) => (
  <Provider store={store}>
    <Router>
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Switch>

            <Route path="/login/" component={Login} />
            <Route path="/cancel_bus_booking/" component={CancelBusBooking} />
            <Route path="/select_seats_forcancel/" component={SelectSeatsTable} />
            <Route path="/cancel_guest/" component={cancelledGuest} />
            <Route path="/cancelled/" component={cancelled} />

            <Route path="/search_tour_package/" component={SearchTourPackage} />
            <Route path={["/seatchart_tour_package/:fromCity/:tourCategory/:tripRoute/:jDate/:variantCode/:busId/:token/:page", "/seatchart_tour_package/:fromCity/:tourCategory/:tripRoute/:jDate/:variantCode/:busId/:token"]} component={ChartTourPackage} />
            <Route path={["/package/exp/:token/:page", "/package/exp/:token"]} component={CheckoutTourPackage} />

            <Route path="/tour-guest-cancel/" component={CancelTourPackage} />
            <Route path="/tour_select_seats_forcancel/" component={SelectSeatsTableTourPackage} />

            <Route path="/" component={ErrorPage} />

          </Switch>
        </Suspense>
      </ErrorBoundary>
    </Router>
  </Provider>
)

export default App;

class ErrorBoundary extends React.Component {
  constructor() {
    super();
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

const ErrorPage = () => (
  <div className='err-screen'>
    Oops! some error occured!
    <br />
    <br />
    <a href='/' target='_self'>GO TO HOME</a>
  </div>
)